export default{

    lista:{
        method:'get',
        url:'boletins/cartaoponto/trabalhador/lista?id={id}'
    },
    cadastra:{
        method:'post',
        url:'boletins/cartaoponto/trabalhador/cadastro'
    },
    cadastradadosboletim:{
        method:'post',
        url:'boletins/cartaoponto/trabalhador/dados/boletim/cadastro'
    },
    updateboletim:{
        method:'post',
        url:'boletins/cartaoponto/trabalhador/dados/boletim/update'
    },
    mostrar:{
        method:'get',
        url:'boletins/cartaoponto/mostrar{/id}'
    },
    delete:{
        method:'delete',
        url:'boletins/cartaoponto/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'boletins/cartaoponto/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'boletins/cartaoponto/trabalhador/update'
    },
    horarios:{
        method:'post',
        url:'boletins/cartaoponto/calcula/horas'
    }
}